import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import EDEStatementsPage from "components/EDEStatements/pages/EDEStatementsPage";
import Classes from "model";
import { useEffect } from "react";

/**
 * @name CaptureMabiEDEStatementsEnrollmentMyStatementsMenuOpen
 * @returns {React.Component}
 * @description A capture in the MABI23 "Statement Preferences (EDE)" capture group.
 */
export default function CaptureMabiEDEStatementsEnrollmentMyStatementsMenuOpen(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    useEffect(() => {
        document.querySelector(".menu-icon-container").click()
    }, []);

    return <EDEStatementsPage />;
}